import { ArrowRight } from '@dreamstack/icons'
import { motion } from 'framer-motion'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import 'twin.macro'
import tw, { styled } from 'twin.macro'
import {
  AnimateIconTranslationRight,
  HeadingH4,
  StyledTileHeader,
  useAnimateIconTranslationRight,
} from '../index'

const StyledWrapper = styled.div<{ backgroundImageUrl?: string }>(
  ({ backgroundImageUrl }) => [
    backgroundImageUrl
      ? `background: linear-gradient( rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.8) ), url(${backgroundImageUrl});`
      : ``,
    tw`bg-accentroGray-full bg-center justify-between p-px-16 h-px-128 md:(h-px-196 p-px-24) lg:(h-px-320 p-px-48) flex cursor-pointer bg-cover`,
  ]
)

const StyledArrowRight = styled(ArrowRight)<{
  $big?: boolean
}>(({ $big }) => [
  tw`text-accentroWhite-full h-px-32 w-px-32`,
  $big && tw`lg:(h-px-64 w-px-64)`,
])

export const CallToActionTile: FunctionComponent<React.PropsWithChildren<{
  caption: string
  href: string
  big?: boolean
  backgroundImageUrl?: string
  targetBlank?: boolean
}>> = ({ caption, href, big, backgroundImageUrl, targetBlank }) => {
  const target = targetBlank ? '_blank' : '_self'
  const { onHoverStart, controls } = useAnimateIconTranslationRight()
  return (
    <Link href={href} passHref legacyBehavior>
      <motion.a onHoverStart={onHoverStart} target={target}>
        <StyledWrapper backgroundImageUrl={backgroundImageUrl}>
          {big ? (
            <StyledTileHeader tw="flex items-end text-accentroWhite-full break-all">
              {caption}
            </StyledTileHeader>
          ) : (
            <HeadingH4 tw="flex items-end text-accentroWhite-full pb-px-32 md:pb-0 break-normal">
              {caption}
            </HeadingH4>
          )}
          <div tw="flex justify-end items-end">
            <AnimateIconTranslationRight animate={controls}>
              <StyledArrowRight $big={big} />
            </AnimateIconTranslationRight>
          </div>
        </StyledWrapper>
      </motion.a>
    </Link>
  )
}
